/**
 * Use this method to show formatted number in application
 *
 * @param {string}
 *
 * @return {string} formatted number
 */
export const getFormattedNumber = (x) => {
  let str = String(x);
  let isMinus = str.startsWith('-');
  let result = str
    .replace('-', '')
    .replaceAll(',', '')
    .replace(/(.)(?=(\d{3})+$)/g, '$1,');
  return isMinus ? `-${result}` : result;
}
